import { render, staticRenderFns } from "./ListClientGroup.vue?vue&type=template&id=0d846f37"
import script from "./ListClientGroup.vue?vue&type=script&lang=js"
export * from "./ListClientGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports